import React, { useState, useEffect } from "react";

import { Container, Row, Col, Card, CardBody, CardTitle, Button, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter, } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const MachineDownTimeUpdation = () => {
  const itemsPerPage = 5;
  const authToken = localStorage.getItem("access");
  const [modalVisible, setModalVisible] = useState(false);
  const [machines, setMachines] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMachine, setSelectedMachine] = useState("");
  const [selectedShift, setSelectedShift] = useState("");
  const [stopTimes, setStopTimes] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [responseMessage, setResponseMessage] = useState("");
  const [responseData, setResponseData] = useState([]);
  const [productionData, setProductionData] = useState([]);
  const [stopDates, setStopDates] = useState([]);
 const [reason,setReason]= useState([]);
  const [selectedOperator, setSelectedOperator] = useState("");
   const [operators, setOperators] = useState([]);
  const toggleModal = () => {
    setModalVisible(!modalVisible);
  }

  useEffect(() => {
    fetchMachines();
    fetchReason();
    fetchOperator();
  }, []);
  
  // function getTodayDate() {
  //   const today = new Date();
  //   return today.toISOString().split("T")[0];
  // }

  const fetchMachines = async () => {
    try {
      const response = await fetch("https://api.hanoch.in/api/machines",
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${authToken}`,
        //   },
        // }
      );

      if (response.ok) {
        const machines = await response.json();
        setMachines(machines);

      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("access");
        // localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

 const fetchReason = async () => {
    try {
      const response = await fetch("https://api.hanoch.in/production-film/stop-reason-types/",
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${authToken}`,
        //   },
        // }
      );

      if (response.ok) {
        const reason = await response.json();
        setReason(reason?.reasons);

      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("access");
        // localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
 const fetchOperator = async () => {
    try {
      const response = await fetch(
        "https://api.hanoch.in/users/operators",
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${authToken}`, // Replace with your actual token
        //   },
        // }
      );
      if (response.ok) {
        const data = await response.json();
        console.log("data", data)
        setOperators(data);
        //selectedChildPart(data[0].number)

      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const isShiftDisabled = (shift) => {
    const now = new Date();
    const currentHour = now.getHours();
    if (shift === "1") {
      return currentHour < 6; // After 2 PM, Shift 1 is over
    } else if (shift === "2") {
      return currentHour < 14; // After 10 PM, Shift 2 is over
    } else if (shift === "3") {
      return currentHour < 22 && currentHour >= 6;
      // Shift 3 (10PM-6AM) is *upcoming* if it's between 6 AM to 10 PM
    }
    return false;
  };

  const [formData, setFormData] = useState({
    id:"",
    reason:"",
    comment:"",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
console.log("wwwwwwwwwwwwwwwwww",formData.reason,formData.comment,formData.id,selectedDate,selectedMachine,selectedShift)
    if (!formData.id || !formData.reason || !formData.comment || !selectedDate|| !selectedMachine || !selectedShift) {
      toast.error("All fields are required.");
      return;
    }
    try {
      setIsLoading(true);
      const apiUrl =
        "https://api.hanoch.in/production-film/update-stop-reason/?id=24&reason&comments/";
      const formDataObject = new FormData();
      formDataObject.append("id", formData.id);
      formDataObject.append("comment", formData.comment);
      formDataObject.append("reason", formData.reason);
      const response = await fetch(apiUrl, {
        method: "PATCH",
        // headers: {
        //   Authorization: `Bearer ${authToken}`,
        // },
        body: formDataObject,
      });

      const responseData = await response.json();
     
      if (response.ok) {
        toast.success(responseData.message);
        setModalVisible(false);
        setFormData({
          machine_id: "",
          comment: "",
          shift: "",
          date: "",
          time: "",
          id:"",
          
        });
       //fetch get api

      } else {
        toast.error(`Error: ${responseData.error}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setIsLoading(false);
    }

  };
 
  const handleMachineChange = async (event) => {
    const machineId = event.target.value;
    setSelectedMachine(machineId);
    setFormData((prev) => ({ ...prev, machine_id: event.target.value }));

    if (machineId) {
      try {
        const response = await fetch(`https://api.hanoch.in/production-film/stopped-dates-without-reason/?machine_id=${machineId}`);
        const data = await response.json();
        const parsedDates = data.stopped_dates.map(date => new Date(date))
        setStopDates(parsedDates); // or setCalendarEvents(data) if directly rendering
      } catch (error) {
        console.error("Failed to fetch machine stop data:", error);
      }
    }
  };

  const fetchStopTimes = async () => {
    if (!selectedMachine || !selectedDate || !selectedShift) {
      console.warn("Missing required parameters");
      return;
    }
   
    try {
      const response = await fetch(
        `https://api.hanoch.in/production-film/stopped-time/?machine_id=${selectedMachine}&date=${selectedDate}&shift=${selectedShift}`
      );
      const data = await response.json();
      setStopTimes(data?.stopped_times); 
    } catch (error) {
      console.error("Error fetching stop times:", error);
    }
  };


  const handleShiftChange = (event) => {
    const newShift = event.target.value;
    setSelectedShift(newShift);
    setFormData((prev) => ({ ...prev, shift: newShift }));
    fetchStopTimes();
  };

  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setSelectedDate(newDate);
    setFormData((prev) => ({ ...prev, date: newDate }));
  };
  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredPart = productionData.filter((part) =>
    (part.name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredPart.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = filteredPart.slice(indexOfFirstItem, indexOfLastItem);

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };


  return (

    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Machine DownTime Updation" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">
                    Add
                  </h4>
                </CardHeader>
                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div className="d-flex gap-1">
                          <Button
                            color="success"
                            className="add-btn"
                            onClick={toggleModal}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {isLoading ? (
                      <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive table-card mt-3 mb-1">
                        <table
                          className="table align-middle table-nowrap"
                          id="customerTable"
                        >
                          <thead className="table-light">
                            <tr>
                              <th className="sort" data-sort="customer_name">
                                Date
                              </th>
                              <th className="sort" data-sort="email">
                                Time
                              </th>
                              <th className="sort" data-sort="phone">
                                Machine Name
                              </th>

                              <th className="sort" data-sort="action">
                                Shift
                              </th>

                              <th className="sort" data-sort="action">
                                Reason
                              </th>
                            </tr>
                          </thead>
                          <tbody className="list form-check-all">
                            {currentItems === undefined ? (
                              <tr>
                                <td colSpan="9" className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : currentItems.length === 0 ? (
                              <tr>
                                <td colSpan="9" className="text-center">
                                  No content found
                                </td>
                              </tr>
                            ) : (
                              currentItems.map((part, index) => (
                                <tr key={index}>

                                  <td className="part_name">
                                    {part.date}
                                  </td>
                                  <td className="part_number">
                                    {part.machine_name}
                                  </td>
                                  <td className="email">
                                    {part.time}
                                  </td>
                                  <td className="email">
                                    {part.shift}
                                  </td>
                                  <td className="email">

                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                        <div className="noresult" style={{ display: "none" }}>
                          <div className="text-center">
                            <lord-icon
                              src="https://cdn.lordicon.com/msoeawqm.json"
                              trigger="loop"
                              colors="primary:#121331,secondary:#08a88a"
                              style={{ width: "75px", height: "75px" }}
                            ></lord-icon>
                            <h5 className="mt-2">Sorry! No Result Found</h5>
                            <p className="text-muted mb-0">
                              We've searched more than 150+ Orders We did not find
                              any orders for you search.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${currentPage === 1 ? "disabled" : ""
                            }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${currentPage === totalPages ? "disabled" : ""
                            }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
         
        </Container>
      </div>


      <Modal
        isOpen={modalVisible}
        toggle={() => {
          setModalVisible(false);
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
          toggle={() => {
            toggleModal();
          }}
        >

        </ModalHeader>
        {responseMessage && (
          <div
            className={`alert ${responseMessage.includes("Error")
                ? "alert-danger"
                : "alert-success"
              } `}
          >
            {responseMessage}
          </div>
        )}
        <form className="tablelist-form">
          <ModalBody>
              <div>
                             <label htmlFor="dentMark" className="col-form-label text-danger">
                               Dent Mark on housing
                             </label>
                             <div className="col-md-10">
                               <input
                                 className="form-control"
                                 type="number"
                                 placeholder="Enter qty"
                                 id="dentMark"
                                 name="dent_mark"
                                 value={formData.dent_mark}
                                 onChange={handleChange}
                               />
                             </div>
                           </div>
                             <div>
                             <label htmlFor="spillage" className="col-form-label text-danger">
                               Spillage
                             </label>
                             <div className="col-md-10">
                               <input
                                 className="form-control"
                                 type="number"
                                 placeholder="Enter qty"
                                 id="spillage"
                                 name="spillage"
                                 value={formData.spillage}
                                 onChange={handleChange}
                               />
                             </div>
                           </div>
                           <div>
                             <label htmlFor="sortRejections" className="col-form-label text-danger">
                               Sort Rejections
                             </label>
                             <div className="col-md-10">
                               <input
                                 className="form-control"
                                 type="number"
                                 placeholder="Enter qty"
                                 id="sortRejections"
                                 name="sort_rejections"
                                 value={formData.sort_rejections}
                                 onChange={handleChange}
                               />
                             </div>
                           </div>
                            <div>
                             <label htmlFor="discolouration" className="col-form-label text-danger">
                               Discolouration
                             </label>
                             <div className="col-md-10">
                               <input
                                 className="form-control"
                                 type="number"
                                 placeholder="Enter qty"
                                 id="discolouration"
                                 name="discolouration"
                                 value={formData.discolouration}
                                 onChange={handleChange}
                               />
                             </div>
                           </div>
                            <div>
                             <label htmlFor="discolouration" className="col-form-label text-danger">
                               Validation Sample
                             </label>
                             <div className="col-md-10">
                               <input
                                 className="form-control"
                                 type="number"
                                 placeholder="Enter qty"
                                 id="discolouration"
                                 name="discolouration"
                                 value={formData.discolouration}
                                 onChange={handleChange}
                               />
                             </div>
                             </div>
                              <div>
                             <label htmlFor="discolouration" className="col-form-label text-danger">
                               Sprue Runner WT(in kg)
                             </label>
                             <div className="col-md-10">
                               <input
                                 className="form-control"
                                 type="number"
                                 placeholder="Enter weight"
                                 id="discolouration"
                                 name="discolouration"
                                 value={formData.discolouration}
                                 onChange={handleChange}
                               />
                             </div>
                           </div>
             <div>
                             <label htmlFor="discolouration" className="col-form-label text-danger">
                             Burn Mask
                             </label>
                             <div className="col-md-10">
                               <input
                                 className="form-control"
                                 type="number"
                                 placeholder="Enter qty"
                                 id="discolouration"
                                 name="discolouration"
                                 value={formData.discolouration}
                                 onChange={handleChange}
                               />
                             </div>
                             </div>
                             <div>
                             <label htmlFor="discolouration" className="col-form-label text-danger">
                              Flash
                             </label>
                             <div className="col-md-10">
                               <input
                                 className="form-control"
                                 type="number"
                                 placeholder="Enter qty"
                                 id="discolouration"
                                 name="discolouration"
                                 value={formData.discolouration}
                                 onChange={handleChange}
                               />
                             </div>
                             </div>
                              <div>
                             <label htmlFor="discolouration" className="col-form-label text-danger">
                              Lumps Wt (in kg)
                             </label>
                             <div className="col-md-10">
                               <input
                                 className="form-control"
                                 type="number"
                                 placeholder="Enter weight"
                                 id="discolouration"
                                 name="discolouration"
                                 value={formData.discolouration}
                                 onChange={handleChange}
                               />
                             </div>
                           </div>
                            <div>
                             <label htmlFor="shortShots" className="col-form-label text-danger">
                               Short Shots
                             </label>
                             <div className="col-md-10">
                               <input
                                 className="form-control"
                                 type="number"
                                 placeholder="Enter qty"
                                 id="shortShots"
                                 name="short_shots"
                                 value={formData.short_shots}
                                 onChange={handleChange}
                               />
                             </div>
                           </div>
                             <div>
                                             <label htmlFor="flash" className="col-form-label text-danger">
                                          Silver streak
                                             </label>
                                             <div className="col-md-10">
                                               <input
                                                 className="form-control"
                                                 type="number"
                                                 placeholder="Enter qty"
                                                 id="flash"
                                                 name="flash"
                                                 value={formData.flash}
                                                 onChange={handleChange}
                                               />
                                             </div>
                                           </div>
                                            <div>
                                             <label htmlFor="flash" className="col-form-label text-danger">
                                              Silver
                                             </label>
                                             <div className="col-md-10">
                                               <input
                                                 className="form-control"
                                                 type="number"
                                                 placeholder="Enter qty"
                                                 id="flash"
                                                 name="flash"
                                                 value={formData.flash}
                                                 onChange={handleChange}
                                               />
                                             </div>
                                           </div>
                           
                                           <div>
                                             <label htmlFor="others" className="col-form-label text-danger">
                                               Residual Mt witht (in Kg)
                                             </label>
                                             <div className="col-md-10">
                                               <input
                                                 className="form-control"
                                                 type="number"
                                                 placeholder="Others"
                                                 id="others"
                                                 name="others"
                                                 value={formData.others}
                                                 onChange={handleChange}
                                               />
                                             </div>
                                           </div>
                                          
                                           <div>
                                             <label htmlFor="setUp" className="col-form-label text-danger">
                                               Set Up
                                             </label>
                                             <div className="col-md-10">
                                               <input
                                                 className="form-control"
                                                 type="number"
                                                 placeholder="Set Up"
                                                 id="setUp"
                                                 name="set_up"
                                                 value={formData.set_up}
                                                 onChange={handleChange}
                                               />
                                             </div>
                                           </div>
                                              <div>
                  <label htmlFor="flash" className="col-form-label text-danger">
                    Scrap Qty
                  </label>
                  <div className="col-md-10">
                    <input
                      className="form-control"
                      type="number"
                      placeholder=""
                      id="flash"
                      name="flash"
                      value={formData.flash}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                 <div>
                  <label htmlFor="flash" className="col-form-label text-danger">
                    scrap Wt
                  </label>
                  <div className="col-md-10">
                    <input
                      className="form-control"
                      type="number"
                      placeholder="Flash"
                      id="flash"
                      name="flash"
                      value={formData.flash}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="setUp" className="col-form-label">
                    Supplier Lot No (Master Batch)
                  </label>
                  <div className="col-md-10">
                    <input
                      className="form-control"
                      type="number"
                      placeholder="Enter Suppiler ID"
                      id="supplier_id"
                      name="set_up"
                      value={formData.set_up}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="shortShots" className="col-form-label text-danger">
                   Qty Rework/Sorting
                  </label>
                  <div className="col-md-10">
                    <input
                      className="form-control"
                      type="number"
                      placeholder="Enter qty"
                      id="shortShots"
                      name="short_shots"
                      value={formData.short_shots}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="others" className="col-form-label text-danger">
                   Parts retunable from assembly
                  </label>
                  <div className="col-md-10">
                    <input
                      className="form-control"
                      type="number"
                      placeholder="Enter qty"
                      id="others"
                      name="others"
                      value={formData.others}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="others" className="col-form-label text-danger">
                    Others
                  </label>
                  <div className="col-md-10">
                    <input
                      className="form-control"
                      type="number"
                      placeholder="Enter Others"
                      id="others"
                      name="others"
                      value={formData.others}
                      onChange={handleChange}
                    />
                  </div>
                   <div className="col-md-10">
                    <input
                      className="form-control"
                      type="number"
                      placeholder="Enter qty"
                      id="supplier_id"
                      name="set_up"
                      value={formData.set_up}
                      onChange={handleChange}
                    />
                  </div>
                </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                onClick={handleSubmit}
              >Save
                {" "}

              </button>
              {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
            </div>
          </ModalFooter>
        </form>
      </Modal>

    </React.Fragment>

  );
};

export default MachineDownTimeUpdation;
